import styled from 'styled-components';

export const Wrapper = styled.div<{ size: number }>`
    margin: auto;
    width: ${(props) => props.size}px;
`;
